import { z } from 'zod'

export const ZGetPhoneNumber = z.object({
  certNum: z.string(),
})

export type TGetPhoneNumber = z.infer<typeof ZGetPhoneNumber>
